import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { AtnaAssistant } from '../components/collectes/AtnaAssistant';
import { AddressCard } from '../components/collectes/AddressCard';
import { CollectionTracker } from '../components/collectes/CollectionTracker';
import { CollectionList } from '../components/collectes/CollectionList';
export function MesCollectes() {
  return <main className="bg-white" data-id="element-2037" data-mp="3gcb0hat7e4qb">
      <div className="mx-auto max-w-[1200px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-2038" data-mp="3gb9sjf7hhyct">
        <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-2039" data-mp="3law47k7nz6ji">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-blue" data-id="element-2040" data-mp="3q3pa4bevckx6">
            Home
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2041" data-mp="3u6vaj2favhvq" />
          <span aria-current="page" data-id="element-2042" data-mp="2zsjcazgpbli">My Collections</span>
        </nav>

        <header className="mt-4" data-id="element-2043" data-mp="7x15snrn81sk">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-2044" data-mp="7y2g2q0u4k98">
            <Link to="/my-collections/calendar" className="group inline-flex items-center gap-2 rounded transition-colors duration-150 ease-ville hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2045" data-mp="82wlewv7hrzr">
              My Collections
              <ChevronRightIcon className="h-7 w-7 text-slate-400 transition-[transform,color] duration-150 ease-ville group-hover:translate-x-0.5 group-hover:text-ville-indigo lg:h-8 lg:w-8" aria-hidden="true" data-id="element-2046" data-mp="3q9kjw3vr3gwg" />
              <span className="sr-only" data-id="element-2047" data-mp="hzhmj743uiyb">See the full calendar</span>
            </Link>
          </h1>
          <p className="mt-3 max-w-2xl text-[17px] leading-relaxed text-slate-600" data-id="element-2048" data-mp="d1znq9jsxk41">
            Check your next collections and get the details for your address in seconds.
          </p>
        </header>

        <div className="mt-8" data-id="element-2049" data-mp="15ou7134vudfx">
          <AtnaAssistant data-id="element-2050" data-mp="15okgnefxe49p" />
        </div>

        <div className="mt-6" data-id="element-2051" data-mp="1omdx7vxpnra5">
          <AddressCard data-id="element-2052" data-mp="1on5iodxlg8mp" />
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-[380px_minmax(0,1fr)] lg:gap-8" data-id="element-2053" data-mp="1oo70r2d11vdx">
          <CollectionTracker data-id="element-2054" data-mp="1tkfgagv4zqlm" />
          <CollectionList data-id="element-2055" data-mp="1fu25m6qv1xsl" />
        </div>
      </div>
    </main>;
}